import { DateCalendar, PickersDay } from "@mui/x-date-pickers";
import { Box } from "@mui/material";
import moment from "moment";
import { Circle } from "@mui/icons-material";

const CalendarComponent = ({
  date,
  onChange,
  onMonthChange,
  markedDates,
}: any) => {
  function CustomDay(props: any) {
    const { day } = props;
    const isMarked = markedDates.some((markedDate: any) =>
      day.isSame(markedDate, "day")
    );

    return (
      <Box sx={{ position: "relative" }}>
        <PickersDay {...props} />
        {isMarked && (
          <Circle
            sx={{
              width: 6,
              height: 6,
              color: "primary.main",
              borderRadius: 50,
              position: "absolute",
              bottom: 4,
              left: "50%",
              transform: "translateX(-50%)",
            }}
          />
        )}
      </Box>
    );
  }

  return (
    <DateCalendar
      defaultValue={moment(date)}
      onChange={onChange}
      onMonthChange={onMonthChange}
      slots={{ day: CustomDay }}
    />
  );
};

export default CalendarComponent;
